export const AIRFLOW_GUID = 'b4af5103-6256-47a3-9375-c067f6287221';
const PORTFOLIO_SERVICE_GUID = '06d01ac9-c889-452f-bb69-3d8ccf3fe6f3';

// Temporary until service identities have backend-provided display names.
// These identities do not have PersonOrg records and must not link to person pages.
const SERVICE_IDENTITY_NAMES = new Map<string, string>([
    [AIRFLOW_GUID, 'Airflow'],
    [PORTFOLIO_SERVICE_GUID, 'Portfolio service'],
]);

export const getServiceIdentityName = (guid: string): string | undefined => SERVICE_IDENTITY_NAMES.get(guid);
